import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlowVariantB} from "../../auth/state/registration_flow_variantB_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {UserSource} from "../../tracking/tracking_utils/user_source";

export interface IFavoriteAuthParams {
    type: "property" | "offer";
}

export const useFavoritesAuth = () => {
    const dispatch = useDispatch();
    const propertyDetail = useSelector((store: IRPStore) => store.property);
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    const auth = (params: IFavoriteAuthParams) => {
        dispatch(
            startRegistrationFlowVariantB({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: params.type === "property" ? UserSource.FAVOURITE_PROPERTY : UserSource.FAVOURITE_OFFER,
                gtmSourceSection: GTMEventApplicationSourceSection.FAVOURITE_BUTTON,
                modalVariant: "extended",
                propertyId: propertyDetail.property?.id ?? undefined,
                offerId: propertyDetail.property?.offer.id ?? undefined,
                titleVariant: AuthModalVariant.FAVORITE
            })
        );
    };

    return auth;
};
import {useDispatch, useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlowVariantB} from "../../auth/state/registration_flow_variantB_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {UserSource} from "../../tracking/tracking_utils/user_source";

export interface IFavoriteAuthParams {
    type: "property" | "offer";
}

export const useFavoritesAuth = () => {
    const dispatch = useDispatch();
    const propertyDetail = useSelector((store: IRPStore) => store.property);
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    const auth = (params: IFavoriteAuthParams) => {
        dispatch(
            startRegistrationFlowVariantB({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: params.type === "property" ? UserSource.FAVOURITE_PROPERTY : UserSource.FAVOURITE_OFFER,
                gtmSourceSection: GTMEventApplicationSourceSection.FAVOURITE_BUTTON,
                modalVariant: "extended",
                propertyId: propertyDetail.property?.id ?? undefined,
                offerId: propertyDetail.property?.offer.id ?? undefined,
                titleVariant: AuthModalVariant.FAVORITE
            })
        );
    };

    return auth;
};
